import GeneratedTaskStore from "./generated/GeneratedTaskStore"

class TaskStore extends GeneratedTaskStore {

}

export const taskStore = new TaskStore()
